<template>
  <el-dialog
      :visible.sync="visible"
      :title="type==='outlet'?'绑定出口发票':'绑定销售开票'"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="1000px"
      :append-to-body="true"
  >
    <el-form
        ref="dataForm"
        :model="dataForm"
        label-width="120px"
        :rules="dataRule"
    >
      <el-form-item label="当前已选择：" >
        <span style="color: red;margin-right: 10px;">{{ rows.length }}</span>行
      </el-form-item>
      <el-form-item :label="type==='outlet'?'出口发票号：':'销售发票号：'" prop="boxReceiptCode">
        <el-input type="text" v-model="dataForm.boxReceiptCode"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button size="small" @click="visible = false">取消</el-button>
      <el-button type="primary" size="small" @click="doSubmit" :disabled="rows.length===0">确定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import moment from 'moment'
import ProductRowCard from '@/components/ProductRowCard.vue'
import { isPositiveNumber } from '@/utils/validate'

export default {
  name: 'bind-box-dialog',
  components: {},
  data () {
    return {
      type:'outlet',
      visible: false,
      rows: [],
      dataForm: {
        boxReceiptCode: '',
      },
      dataRule: {
        boxReceiptCode: [{ required: true, message: '请输入出口发票号', trigger: 'change' },],
      }
    }
  },
  methods: {
    init (rows) {
      this.dataForm = {
        boxReceiptCode: ''
      }
      this.$set(this,'rows',rows)
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    async doSave () {
      let postForm = {
        ...this.dataForm,
        ids: this.rows.map(row => row.id)
      }
      let loading = this.$loading({
        lock: true,
        text: '正在提交中...'
      })
      try {
        let res = await this.$api2.post('/erp/box/detail/bind', postForm)
        this.$message.success('保存成功')
        this.$emit('changed')
        this.visible = false
      } catch (e) {
        console.log(e)
      } finally {
        loading.close()
      }
    },
    doSubmit () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.doSave()
      })
    }
  }
}
</script>

<style scoped>

</style>
